import React from "react";
import { useAppState } from "../../../Redux/ReduxHooks";
import { BookingStatus } from "../../../Services/BookingEntities";

/**
 * Displays the trip duration and the distance between the pickup and destination. Ths is dynamic and initially will contain only estimated values and after the trip is completed, it will contain the actual values.
 */
export const TripDurationAndDistance: React.FC = () => {

    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    // Don't display this when the status is Cancelled or No Job.
    if (bookingDetails.TrackingInfo.BookingStatusID > BookingStatus.Completed) return null;

    const description = bookingDetails.TrackingInfo.BookingStatusID === BookingStatus.Completed ? "Trip " : "Trip ~ ";

    return (
        <div className="trip-duration-and-distance">
            <div>{description}{bookingDetails.Fare.TravelTimeMinutes} mins ({bookingDetails.Fare.DistanceKm} km)</div>
        </div>
    )
}